import { Injectable } from '@angular/core';
import * as crypto from 'crypto-ts';
import moment from 'moment';
import { environment } from '../../../../environments/environment';


@Injectable({
  providedIn: 'root'
})
export class EncryptionService {
  constructor() { }

  decryptAllTextFields<T>(data: T): Promise<T> {
    return new Promise<T>((resolve, reject) => {
      try {
        // eslint-disable-next-line  @typescript-eslint/no-explicit-any
        const traverse = (obj: any) => {
          for (const key in obj) {
            try {
              if (moment(obj[key], moment.ISO_8601, true).isValid() || typeof obj[key] === 'boolean') {
                continue;
              }
              if (typeof obj[key] === 'string' && obj[key]) {
                const iv = crypto.enc.Hex.parse(obj[key].slice(0, 32));
                const decryptedValue = crypto.AES.decrypt(
                  // eslint-disable-next-line  @typescript-eslint/no-explicit-any
                  { ciphertext: crypto.enc.Hex.parse(obj[key].slice(32)) } as any,
                  crypto.enc.Hex.parse(environment.enc_pass),
                  { iv: iv }
                );
                obj[key] = decryptedValue.toString(crypto.enc.Utf8);
              } else if (typeof obj[key] === 'object') {
                traverse(obj[key]);
              }
            } catch (error) {
              reject(error instanceof Error ? error : new Error(String(error)));
            }

          }
        };

        traverse(data);
        resolve(data);
      } catch (error) {
        console.error('Decryption failed', error);
        reject(error instanceof Error ? error : new Error(String(error)));
      }
    });
  }

  async encryptAllTextFields<T>(data: T): Promise<T> {
    return new Promise<T>((resolve, reject) => {
      try {
        const visited = new WeakSet();
        // eslint-disable-next-line  @typescript-eslint/no-explicit-any
        const traverse = (obj: any) => {
          if (obj && typeof obj === 'object') {
            if (visited.has(obj)) return; // prevent re-processing
            visited.add(obj);

            for (const key in obj) {
              if (!Object.hasOwn(obj, key)) continue;

              const val = obj[key];

              if (typeof val === 'string' && val) {
                const iv = this.generateRandomBytes(16);
                const cipher = crypto.AES.encrypt(val, crypto.enc.Hex.parse(environment.enc_pass), {
                  iv: crypto.enc.Hex.parse(iv),
                });
                const encrypted = cipher.ciphertext?.toString(crypto.enc.Hex);
                obj[key] = iv + encrypted;
              } else if (typeof val === 'object' && val !== null) {
                traverse(val);
              }
            }
          }
        };

        traverse(data);
        resolve(data);
      } catch (error) {
        reject(error instanceof Error ? error : new Error(String(error)));
      }
    });
  }

  generateRandomBytes(size: number): string {
    const bytes = new Uint8Array(size);
    window.crypto.getRandomValues(bytes);
    const hexString = Array.from(bytes)
      .map(byte => byte.toString(size).padStart(2, '0'))
      .join('');
    return hexString;
  }

}